//ie11
objectFitImages();
$(function(){
	//ブラウザ判定
	var ua = UAParser()
	var uaString = {
		browserName: ua.browser.name.toLowerCase().replace(' ', '-'),
		browserVersion: ua.browser.major,
		browserEngine: ua.engine.name.toLowerCase().replace(' ', '-'),
		osName: ua.os.name.toLowerCase().replace(' ', '-'),
		type: (typeof ua.device.type !== 'undefined') ? ua.device.type.toLowerCase().replace(' ', '-') : 'laptop'
	}
	$('html').attr('browser', uaString.browserName)
	$('html').attr('browserversion', uaString.browserVersion)
	$('html').attr('browserengine', uaString.browserEngine)
	$('html').attr('os', uaString.osName)
	$('html').attr('type', uaString.type)

	//scroll
	$('a[href^="#"]').click(function () {
		var speed = 500;
		var href = $(this).attr("href");
		if ($(this).hasClass('js-top')) {
			href = 'body';
		}
		var target = $(href);
		var position = target.offset().top;
		$("html, body").animate({ scrollTop: position }, speed, "swing");
		return false;
	});

	$(window).scroll(function(){
		if ($(window).scrollTop() > 100) {
			$('.pagetop').stop().fadeTo(300, 1);
		} else {
			$('.pagetop').stop().fadeTo(200, 0, function(){
				$('.pagetop').hide();
			});
		}
	}).scroll();
})